import { useState } from "react";

export const usePopupDisplay = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const hidePopup = () => {
    setPopupVisible(false);
  };

  const showPopUp = () => {
    setPopupVisible(true);
  };

  return {
    popupVisible,
    showPopUp,
    hidePopup,
  };
};
